import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/lib/api';
import { ErrorText, PageHeader } from '@/components/ui';
import { PosterChoices } from '@/components/poster-card';

/** `/e/:slug/poster`: printable and shareable posters for an event. */
export function EventPosterPage() {
  const { slug = '' } = useParams();
  const api = useApi();
  const info = useQuery({
    queryKey: ['publicEvent', slug],
    queryFn: () => api.publicEvent(slug),
    retry: false,
  });

  if (info.isPending) return <p className="text-sm text-muted-foreground">Loading…</p>;
  if (info.isError) return <ErrorText error={info.error} />;

  return (
    <div>
      <PageHeader
        title="Event poster"
        description={`A one-page poster for “${info.data.title}” with the dates and a QR code to register. Print it for notice boards and common areas, or share the dark version online.`}
        back={{ to: `/e/${slug}`, label: info.data.kind === 'webinar' ? 'Webinar' : 'Workshop' }}
      />
      <PosterChoices
        source={{
          key: ['event', slug],
          file: (theme, format, size = 'letter') =>
            api.posterFile(slug, theme, format, size, 'event'),
          fileName: (theme, d) =>
            `Nirvik-Ready-Event-Poster-${slug}-${theme}${
              d.format === 'pdf' ? `-${d.size ?? 'letter'}` : ''
            }`,
        }}
      />
    </div>
  );
}
